export const UserPermOptions = {
  DEFAULT: "Default",
  SPANISH: "Spanish RA",
  FULL: "Full-level",
  DELETE: "Delete user from REDCap Projects",
};
